import { useEffect, useRef } from "react";
import type { UseGoalFormReturn } from "web_myplann/Goals/Forms/useGoalForm";
import { useGoalCategoryStrings } from "web_myplann/Goals/Hooks/useGoalCategoryStrings";
import type { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const useSuggestedGoalName = (
	form: UseGoalFormReturn,
	category: GoalCategoryTypeEnum | undefined,
) => {
	const { getValues, setValue } = form;
	const { defaultName, sectionTitle } = useGoalCategoryStrings(category);
	const lastSuggestedNameRef = useRef("");

	useEffect(() => {
		if (!category) return;
		const currentName = getValues("name") ?? "";
		if (currentName === "" || currentName === lastSuggestedNameRef.current) {
			setValue("name", defaultName, {
				shouldDirty: false,
				shouldValidate: false,
			});
		}
		lastSuggestedNameRef.current = defaultName;
	}, [category, defaultName, getValues, setValue]);

	return { sectionTitle };
};
